import { notify } from '../../actions/notifications';
import {
  setOffersByRealtyOfferId,
  setOffersByRealtyOfferIdFailed,
  setOffersByRealtyOfferIdLoading,
} from '../../actions/offersByRealtyOfferId';
import {
  fetchWebGetFolderOffersByRealtyOfferId,
  IWebGetFolderOffersByRealtyOfferIdRequest,
  IWebGetFolderOffersByRealtyOfferIdResponse,
  TWebGetFolderOffersByRealtyOfferIdResponse,
} from '../../repositories/favorites/v1/web-get-folder-offers-by-realty-offer-id';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const getFolderOffersByRealtyOfferId =
  (parameters: IWebGetFolderOffersByRealtyOfferIdRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () =>
      dispatch(notify('Не получилось загрузить данные по индификаторам объявлений', ENotificationStyle.Error));

    dispatch(setOffersByRealtyOfferIdLoading());

    try {
      const { statusCode, response }: TWebGetFolderOffersByRealtyOfferIdResponse =
        await fetchWebGetFolderOffersByRealtyOfferId({ httpApi, parameters });

      if (statusCode === 200) {
        dispatch(setOffersByRealtyOfferId(response as IWebGetFolderOffersByRealtyOfferIdResponse));
      }

      if (statusCode === 400) {
        logger.warning(response.message);
        showError();
        dispatch(setOffersByRealtyOfferIdFailed());
      }
    } catch (e) {
      logger.error(e, { description: 'Failed to get offers by realty offer id by folder' });
      showError();
      dispatch(setOffersByRealtyOfferIdFailed());
    }
  };
